import { gql } from "@apollo/client";

//Query
export const getUserVerifiedInfoQuery = gql`
query getUserVerifiedInfo($userId: String!) {
  getUserVerifiedInfo(userId: $userId) {
    id
    isEmailConfirmed
    isFacebookConnected
    isGoogleConnected
    isIdVerification
    status
  }
}`;